/* TT theme: mobile menu, product options, gallery, sorting */
(function () {
  const menuBtn = document.querySelector('.menu-btn');
  if (menuBtn) {
    menuBtn.addEventListener('click', () => {
      const nav = document.querySelector('.nav');
      const open = nav.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', String(open));
    });
  }

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const dataEl = form.querySelector('[data-product-json]');
    if (!dataEl) return;
    const product = JSON.parse(dataEl.textContent);
    const idInput = form.querySelector('input[name="id"]');
    const addBtn = form.querySelector('[data-add]');
    const root = form.closest('[data-pdp]') || document;
    const priceEl = root.querySelector('[data-price]');
    const compareEl = root.querySelector('[data-compare]');
    const money = (cents) => '£' + (cents / 100).toFixed(2).replace(/\.00$/, '');

    function selected() {
      return product.options.map((_, i) => {
        const checked = form.querySelector('input[name="option-' + i + '"]:checked');
        return checked ? checked.value : null;
      });
    }
    function update() {
      const opts = selected();
      product.options.forEach((_, i) => {
        const label = form.querySelector('[data-option-value="' + i + '"]');
        if (label) label.textContent = opts[i] || '';
      });
      const v = product.variants.find((x) => x.options.every((o, i) => o === opts[i]));
      if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to bag' : 'Sold out';
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        compareEl.hidden = !(v.compare_at_price > v.price);
        if (v.compare_at_price) compareEl.textContent = money(v.compare_at_price);
      }
      if (v.featured_media) {
        const btn = root.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (btn) btn.click();
      }
      const url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
    }
    form.addEventListener('change', (e) => { if (e.target.name && e.target.name.indexOf('option-') === 0) update(); });

    const qty = form.querySelector('input[name="quantity"]');
    const dec = form.querySelector('[data-qty-dec]');
    const inc = form.querySelector('[data-qty-inc]');
    if (dec) dec.addEventListener('click', () => { qty.value = Math.max(1, (+qty.value || 1) - 1); });
    if (inc) inc.addEventListener('click', () => { qty.value = Math.min(99, (+qty.value || 1) + 1); });
  });

  document.querySelectorAll('[data-gallery]').forEach((g) => {
    const main = g.querySelector('[data-main-img]');
    g.querySelectorAll('[data-media-id]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (main) { main.src = btn.dataset.src; main.removeAttribute('srcset'); main.alt = btn.dataset.alt || ''; }
        g.querySelectorAll('[data-media-id]').forEach((b) => b.setAttribute('aria-current', String(b === btn)));
      });
    });
  });

  document.querySelectorAll('[data-sort]').forEach((sel) => {
    sel.addEventListener('change', () => {
      const url = new URL(location.href);
      url.searchParams.set('sort_by', sel.value);
      location.href = url.toString();
    });
  });
})();
